import {useAxiosCreate,updateHeader} from '@/backend/utils.js'
import authHeader from '@/backend/auth/auth-header';
import { ref } from 'vue'
import { clearOptionsCache } from '@/store/apiStorage';
import {
  clearStoredAuth,
  getRefreshToken,
  writeStoredAuth,
} from '@/backend/auth/tokenStorage.mjs'
import { unsyncWebPushSubscription } from '@/backend/webPushClient'

class ApiConnector {

  constructor() {
    this.api = useAxiosCreate();
  }

  async logout() {
    try {
      await unsyncWebPushSubscription()
    } catch (_) {
      // подписку снимаем best-effort
    }
    const refreshToken = getRefreshToken()
    if (refreshToken) {
      try {
        await this.api.post('/auth/logout', { refresh_token: refreshToken })
      } catch (_) {
        // revoke best-effort — локальный logout всё равно выполняем
      }
    }
    clearStoredAuth()
    clearOptionsCache();
    updateHeader(this.api)
  }

  async login(email, password) {
    const formData = new URLSearchParams();
    formData.append('username', email);
    formData.append('password', password);
    
    const response = await this.api.post('/auth/token', formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
    if(response.data.access_token) {
      writeStoredAuth(response.data)
    }
    updateHeader(this.api)
    return response;
  }

  async register(email,password,name) {
    const formData = new URLSearchParams();
    const data = {email:email, password:password, name:name}
    const response = await this.api.post('users/', data);
    return response;
  }

  async getUser() {
    return await this.api.get('/users/me');
  }

  async createTgBindCode() {
    return await this.api.post('/users/tg_bind_code');
  }

  async disconnectTg() {
    return await this.api.delete('/users/me/tg');
  }

  async deleteUser(userId) {
    return await this.api.delete('/users/delete/'+userId);
  }

  async getUsers() {
    return await this.api.get('/users/');
  }

  async getUsersV2() {
    return await this.api.get('/api/v2/users/');
  }

  async createUserV2(data) {
    return await this.api.post('/api/v2/users/', data);
  }

  async updateUserV2(userId, data) {
    return await this.api.put(`/api/v2/users/${userId}`, data);
  }

  async setUserActiveV2(userId, isActive) {
    return await this.api.patch(`/api/v2/users/${userId}/active`, { is_active: isActive });
  }

  async resetUserPasswordV2(userId) {
    return await this.api.post(`/api/v2/users/${userId}/reset-password`);
  }

  async listUserSignatures(userId) {
    return await this.api.get(`/api/v2/users/${userId}/signatures`);
  }

  async uploadUserSignature(userId, file) {
    const formData = new FormData();
    formData.append('file', file);
    return await this.api.post(`/api/v2/users/${userId}/signatures`, formData);
  }

  async replaceUserSignature(userId, signatureId, file) {
    const formData = new FormData();
    formData.append('file', file);
    return await this.api.put(`/api/v2/users/${userId}/signatures/${signatureId}`, formData);
  }

  async deleteUserSignature(userId, signatureId) {
    return await this.api.delete(`/api/v2/users/${userId}/signatures/${signatureId}`);
  }

  async getUserSignatureFile(userId, signatureId) {
    return await this.api.get(`/api/v2/users/${userId}/signatures/${signatureId}/file`, {
      responseType: 'blob',
    });
  }

  async impersonate(userId) {
    return await this.api.post(`/auth/impersonate/${userId}`);
  }

  async getRoles() {
    return await this.api.get('/users/roles');
  }

  async getPermissionsCatalog() {
    return await this.api.get('/users/permissions');
  }

  async getRolesV2() {
    return await this.api.get('/api/v2/users/roles');
  }

  async updateUserRole(data) {
    return await this.api.put('/users/roles', data);
  }

  async updateRole(roleId, data) {
    return await this.api.put(`/users/roles/${roleId}`, data);
  }

  put(id,form){
		const response = ref()
		const request = async ()=>{
			const res = await this.api.put(id.toString(),JSON.stringify(form),{headers: authHeader()})
			response.value = res.data
		}
		return {response,request};
	}

}

export default ApiConnector;
